import React from 'react';

//Material
import CloseIcon from '@mui/icons-material/Close';

import { Box, Grid, Modal, Typography } from '@mui/material';

import { connect, useDispatch } from 'react-redux';
import { StyledLabel } from '../../components/StyledComponents';
import { setIsOpenPremiumCancelModal } from '../../redux/mainReducer';

import './DeleteModal.css';
import { LetsGoBtn } from '../../components/Buttons';
import { base } from '../../redux/thunk';
import ApiService from '../../helpers/apiHelper';
import { useSnackbar } from 'notistack';
import { useNavigate } from 'react-router-dom';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '100%',
  maxWidth: {
    xs: 390,
    sm: 500,
    md: 550,
    xl: 550
  },
  bgcolor: 'background.paper',
  borderRadius: '20px',
  border: 'none',
  boxShadow: 24,
  padding: { xs: '20px 20px 20px 20px', sm: '50px 60px 50px 60px' },
  overflow: 'scroll',
  height: 'inherit',
  maxHeight: '100vh',
  scrollbarWidth: 'none',
  '&::-webkit-scrollbar': {
    display: 'none'
  }
};

function PremiumCancelModal({ isOpenModal, getUserDataThunk, iframe }) {
  const dispatch = useDispatch();
  const api = new ApiService('auth/cancel-premium');
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const [isError, setIsError] = React.useState(false);
  return (
    <div>
      <Modal
        open={isOpenModal}
        onClose={(event, reason) => {
          if (reason === 'backdropClick') {
            return;
          }

          dispatch(setIsOpenPremiumCancelModal(false));
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="bonfair_delete_modal"
      >
        <Box sx={style} className="bonfair_delete_modal-box">
          <CloseIcon
            className="bonfair_delete_modal-close"
            style={{ position: 'absolute', right: '10px', top: '10px', cursor: 'pointer' }}
            onClick={() => {
              dispatch(setIsOpenPremiumCancelModal(false));
            }}
          />

          <Grid container spacing={1}>
            <Grid item xs={12} md={12} lg={12}>
              <StyledLabel
                sx={{ maxWidth: '400px', m: '0px auto' }}
                className="deleteModal-title-text"
              >
                {isError ? 'Скасування неможливе' : 'Ви впевнені?'}
              </StyledLabel>
            </Grid>
            <Grid item xs={12} md={12} lg={12} sx={{ display: 'flex', justifyContent: 'center' }}>
              {isError ? (
                <Typography
                  variant="p"
                  sx={{
                    margin: '0px',
                    wordBreak: 'break-word',
                    fontFamily: 'FixelText-Regular !important',
                    fontSize: { xs: '16px', sm: '18px' },
                    textAlign: 'justify'
                  }}
                >
                  На жаль, зараз не можемо скасувати преміум-підписку — деякі з ваших товарів ще
                  задіяні в активних замовленнях. <br />
                  <br />
                  Дочекайтесь, поки замовлення буде отримано або скасовано. Або вручну скасуйте ці
                  замовлення на сторінці замовлень. <br />
                </Typography>
              ) : (
                <Typography
                  variant="p"
                  sx={{
                    margin: '0px',
                    wordBreak: 'break-word',
                    fontFamily: 'FixelText-Medium !important',
                    fontSize: { xs: '16px', sm: '18px' },
                    textAlign: 'left'
                  }}
                >
                  Після скасування преміум-підписки: <br />
                  <Typography
                    variant="p"
                    sx={{
                      fontFamily: 'FixelText-Regular !important',
                      fontSize: { xs: '16px', sm: '18px' },
                      color: '#7C7C7C'
                    }}
                  >
                    • Усі ваші товари, крім першого, будуть видалені <br />
                  </Typography>
                  <Typography
                    variant="p"
                    sx={{
                      fontFamily: 'FixelText-Regular !important',
                      fontSize: { xs: '16px', sm: '18px' },
                      color: '#7C7C7C'
                    }}
                  >
                    • Ви втратите доступ до преміум-функцій
                  </Typography>
                </Typography>
              )}
            </Grid>
            {/*<Grid item xs={12} md={12} lg={12} sx={{ display: 'flex', justifyContent: 'center' }}>*/}
            {/*  <Typography*/}
            {/*    variant="p"*/}
            {/*    sx={{*/}
            {/*      margin: '0px',*/}
            {/*      wordBreak: 'break-word',*/}
            {/*      fontFamily: 'FixelText-Regular !important',*/}
            {/*      fontSize: '14px',*/}
            {/*      textAlign: 'center'*/}
            {/*    }}*/}
            {/*  >*/}
            {/*    Ці товари будуть залишатись неактивними на вашому акаунті <br />*/}
            {/*    протягом 3 місяців. Якщо ви не відновите Преміум-підписку*/}
            {/*    <br /> протягом цього періоду, вони будуть безповоротно видалені.*/}
            {/*  </Typography>*/}
            {/*</Grid>*/}
            <Grid item xs={12} md={12} lg={12} sx={{ display: 'flex', justifyContent: 'center' }}>
              <LetsGoBtn
                className="service-card-btn"
                width="250px"
                margin={{ xs: '10px 0px 0px 0px', sm: '20px 0px 0px 0px' }}
                text={isError ? 'Сторінка замовлень' : 'Підтвердити скасування'}
                onClick={() => {
                  if (!isError) {
                    api
                      .sendRequest()
                      .then((res) => {
                        getUserDataThunk();
                        const iframe = document.getElementById('accSettingsPage');
                        if (iframe) {
                          iframe?.contentWindow.postMessage(
                            'REFRESH SUBSCRIPTION',

                            '*'
                          );
                        }

                        dispatch(setIsOpenPremiumCancelModal(false));
                      })
                      .catch((err) => {
                        enqueueSnackbar(err, { variant: 'error' });
                        setIsError(true);
                      });
                  } else {
                    navigate('/ua/scheduler?tab=1&sd=DESC&status=&question=');
                    dispatch(setIsOpenPremiumCancelModal(false));
                  }
                }}
              />
            </Grid>
            {!isError && (
              <Grid item xs={12} md={12} lg={12} sx={{ display: 'flex', justifyContent: 'center' }}>
                <Typography
                  variant="p"
                  sx={{
                    margin: { xs: '10px 0px 0px !important', sm: '20px 0px 0px !important' },
                    wordBreak: 'break-word',
                    fontFamily: 'FixelText-Regular !important',
                    fontSize: { xs: '16px', sm: '18px' },
                    textAlign: 'center'
                  }}
                >
                  Цю дію не можна буде скасувати!
                </Typography>
              </Grid>
            )}
          </Grid>
        </Box>
      </Modal>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    language: state.Intl.locale
  };
};
export default connect(mapStateToProps, {
  getUserDataThunk: base.getUserDataThunk
})(PremiumCancelModal);
